import { useSelector, useDispatch } from 'react-redux';
import FJModal from '../FJModal';
import FJWarningModal from './FJWarningModal';
import FJActionModal from '../../../redux/action/FJActionModal';
const FJWarningModalContainer = () => {
    const dispatch = useDispatch();
    const warningModalData = useSelector(state => state.modals.warningModalData);
    const { title, content, display, footerDates, closeCallback, isShowApplyBtn, checkBoxText } = warningModalData;
    const onClose = () => {
        dispatch(FJActionModal.hideWarningModalAction());
        closeCallback && closeCallback();
    };

    return (
        <FJModal visible={display} zIndex={1003}>
            <FJWarningModal
                title={title}
                content={content}
                footerDates={footerDates}
                isShowApplyBtn={isShowApplyBtn}
                onClose={onClose}
                isShow={display}
                checkBoxText={checkBoxText}
            />
        </FJModal>
    );
};
export default FJWarningModalContainer;
